export const fonte = "https://gilbertomelo.com.br/pdf/JEBR0525N.pdf";

let indices = [];

indices["2005"] = [
  3.0354745,
  3.0182703,
  3.0050481,
  2.9832702,
  2.9563673,
  2.9358166,
  2.9390495,
  2.9381681,
  2.9381681,
  2.9337674,
  2.9168497,
  2.9011833,
];

indices["2006"] = [
  2.8896248,
  2.8786858,
  2.8720800,
  2.8643463,
  2.8609132,
  2.8571988,
  2.8592003,
  2.8560586,
  2.8566299,
  2.8520666,
  2.8398552,
  2.8279777,
];

indices["2007"] = [
  2.8105523,
  2.7968478,
  2.7851501,
  2.7729492,
  2.7657582,
  2.7585859,
  2.7500607,
  2.7412885,
  2.7252098,
  2.7184138,
  2.7102829,
  2.6986786,
];

indices["2008"] = [
  2.6727529,
  2.6544373,
  2.6417569,
  2.6283523,
  2.6116378,
  2.5868045,
  2.5634768,
  2.5486944,
  2.5433533,
  2.5395440,
  2.5269095,
  2.5173436,
];

indices["2009"] = [
  2.5100644,
  2.4941021,
  2.4863943,
  2.4814314,
  2.4678582,
  2.4531394,
  2.4428793,
  2.4372736,
  2.4353253,
  2.4314350,
  2.4256135,
  2.4166719,
];

indices["2010"] = [
  2.4108857,
  2.3898550,
  2.3732423,
  2.3565111,
  2.3394332,
  2.3294167,
  2.3319819,
  2.3336154,
  2.3352501,
  2.3227075,
  2.3015334,
  2.2780693,
];

indices["2011"] = [
  2.2644824,
  2.2433945,
  2.2313452,
  2.2167149,
  2.2008686,
  2.1883948,
  2.1835909,
  2.1835909,
  2.1744582,
  2.1647169,
  2.1578119,
  2.1455821,
];

indices["2012"] = [
  2.1346952,
  2.1238635,
  2.1156126,
  2.1118113,
  2.0983817,
  2.0869037,
  2.0814918,
  2.0725797,
  2.0632949,
  2.0503775,
  2.0359225,
  2.0249875,
];

indices["2013"] = [
  2.0101127,
  1.9917883,
  1.9814845,
  1.9696665,
  1.9581137,
  1.9512842,
  1.9458358,
  1.9483687,
  1.9452563,
  1.9400183,
  1.9282559,
  1.9178992,
];

indices["2014"] = [
  1.9041891,
  1.8922678,
  1.8802343,
  1.8649418,
  1.8505078,
  1.8394710,
  1.8347008,
  1.8323187,
  1.8290265,
  1.8201080,
  1.8132177,
  1.8036584,
];

indices["2015"] = [
  1.7925446,
  1.7664018,
  1.7461465,
  1.7201719,
  1.7080448,
  1.6913009,
  1.6783774,
  1.6686990,
  1.6645376,
  1.6560916,
  1.6434371,
  1.6253952,
];

indices["2016"] = [
  1.6108971,
  1.5869344,
  1.5720004,
  1.5651139,
  1.5551609,
  1.5400682,
  1.5328638,
  1.5231158,
  1.5184088,
  1.5171950,
  1.5146201,
  1.5135607,
];

indices["2017"] = [
  1.5114446,
  1.5051231,
  1.5015195,
  1.4967299,
  1.4955335,
  1.4901689,
  1.4946529,
  1.4921163,
  1.4925640,
  1.4928626,
  1.4873594,
  1.4846869,
];

indices["2018"] = [
  1.4808368,
  1.4774386,
  1.4747840,
  1.4737524,
  1.4706640,
  1.4643672,
  1.4437220,
  1.4401217,
  1.4401217,
  1.4358143,
  1.4300939,
  1.4336781,
];

indices["2019"] = [
  1.4316737,
  1.4265382,
  1.4188763,
  1.4080344,
  1.3996366,
  1.3975403,
  1.3974005,
  1.3960045,
  1.3943313,
  1.3950288,
  1.3944711,
  1.3869814,
];

indices["2020"] = [
  1.3702641,
  1.3676656,
  1.3653445,
  1.3628913,
  1.3660332,
  1.3694568,
  1.3653607,
  1.3593794,
  1.3545032,
  1.3428207,
  1.3309750,
  1.3184497,
];

indices["2021"] = [
  1.2994774,
  1.2959782,
  1.2854376,
  1.2744771,
  1.2696525,
  1.2575797,
  1.2500792,
  1.2374572,
  1.2266625,
  1.2121171,
  1.1982178,
  1.1882366,
];

indices["2022"] = [
  1.1796253,
  1.1717745,
  1.1601727,
  1.1406673,
  1.1289265,
  1.1238691,
  1.1169440,
  1.1236861,
  1.1271804,
  1.1307990,
  1.1255091,
  1.1212483,
];

indices["2023"] = [
  1.1135647,
  1.1084658,
  1.0999958,
  1.0930006,
  1.0872382,
  1.0833382,
  1.0844226,
  1.0853995,
  1.0832330,
  1.0820428,
  1.0807459,
  1.0796662,
];

indices["2024"] = [
  1.0737606,
  1.0676748,
  1.0590961,
  1.0570877,
  1.0531909,
  1.0483684,
  1.0457540,
  1.0430421,
  1.0445044,
  1.0399287,
  1.0341375,
  1.0301200,
];

indices["2025"] = [
  1.0247911,
  1.0231541,
  1.0099241,
  1.0043000,
  1.0000000,
  0.0000000,
  0.0000000,
  0.0000000,
  0.0000000,
  0.0000000,
  0.0000000,
  0.0000000,
];

export default indices;




// WEBPACK FOOTER //
// ./src/config/indices.js